<template>
  <div class="animated fadeIn">
    <b-card>
      <p class="h2">集計</p>
      <p> CPU社内アカウントを除いた全アカウントの集計結果を表示します。前日までの集計結果が取得できます。</p>
      <div>
      <form class="form-inline">
        <div class="form-group ">
          開始日
          <b-form-input v-model="starttime" type="date" style="font-size: 16px; margin-left: 8px;"></b-form-input>
        </div>
        <div class="form-group mx-sm-3">
          終了日
          <b-form-input v-model="endtime" type="date" style="font-size: 16px; margin-left: 8px;"></b-form-input>
        </div>
        <b-button variant="primary" @click="refresh()">
          <i class="fa fa-refresh"></i> 更新
        </b-button>
        <b-button variant="primary" @click="dwonloadCSV()" style="margin-left:10px;">
          <i class="fa fa-cloud-download"></i> CSVダウンロード
        </b-button>
      </form>
      </div><br>
      <div>
        <table class="table-sm table-striped table-borderless">
          <thead style="border:solid 0px;">
            <tr>
              <th width="140">日時</th>
              <th>アクティブユーザー</th>
              <th>QRコード出力</th>
              <th>QRコードDL</th>
              <th>公開数</th>
              <th>非公開数</th>
              <th>削除数</th>
              <th>現時点の公開数</th>
            </tr>
          </thead>
          <tbody>
           <tr v-for="item in this.items" :key="item.time">
            <td>{{ item.time }}</td>
            <td>{{ item.activeusers }}</td>
            <td>{{ item.uploadcount }}</td>
            <td>{{ item.downloadcount }}</td>
            <td>{{ item.publiccount }}</td>
            <td>{{ item.privatecount }}</td>
            <td>{{ item.deletecount }}</td>
            <td>{{ item.publicstatecount }}</td>
           </tr>
          </tbody>
        </table>
      </div>
      <div>
        <spinner v-show="isLoading" :line-size="4" :size="60" :speed="0.8" line-fg-color="#B23E53" style="margin:10px;"></spinner>
      </div>
    </b-card>
    <b-card>
      <AggregateChart chartId="main-chart-01" class="chart-wrapper" style="height:500px;margin-top:40px;" :data="chartData" :options="chartOptions"></AggregateChart>
    </b-card>
  </div>
</template>

<script>
import Store from '@/store'
import ApiAccess from '@/components/ApiAccess'
import Spinner from 'vue-simple-spinner'
import AggregateChart from '@/views/home/AggregateChart'

export default {
  name: 'tables',
  mixins: [ ApiAccess ],
  components: {
    Spinner,
    AggregateChart
  },
  data: () => {
    return {
      fields: {
        time: {
          label: '時間',
          sortable: false,
          width: '5px'
        },
        text: {
          label: '履歴',
          sortable: false
        }
      },
      items: [],
      currentPage: 1,
      perPage: 12,
      totalRows: 0,
      isLoading: false,
      searchFlg: false,
      serachInputText: '',
      searchText: '',
      starttime: '2018-01-01',
      endtime: '2018-07-31',
      days: [],
      chartData: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  created: function () {
    var startDate = new Date()
    var endDate = new Date()
    startDate.setDate(startDate.getDate() - 30)
    endDate.setDate(endDate.getDate() - 1)
    this.endtime = this.dateToString(endDate)
    this.getDatas()
  },
  methods: {
    getDatas: async function () {
      this.isLoading = true
      var log = await this.$_Api_GetAggregateList(Store.state.token, this.starttime, this.endtime)
      this.items = log.data
      this.isLoading = false

      this.makeChartData()
    },
    async refresh () {
      this.items.length = 0
      await this.getDatas()
    },
    dateToString (date) {
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + (date.getDate())).slice(-2)
      return date.getFullYear() + '-' + m + '-' + d
    },
    dwonloadCSV () {
      var csv = '\ufeff' + '日時,アクティブユーザー,QRコード出力,QRコードDL,公開数,非公開数,削除数,現時点の公開数\n'
      this.items.forEach(el => {
        var line = el['time'] + ',' + el['activeusers'] + ',' + el['uploadcount'] + ',' + el['downloadcount'] + ',' + el['publiccount'] + ',' + el['privatecount'] + ',' + el['deletecount'] + ',' + el['publicstatecount'] + '\n'
        csv += line
      })
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = '集計.csv'
      link.click()
    },
    makeChartData () {
      var newData = []
      var labels = []
      var activeusersChart = {
        label: 'アクティブユーザー',
        backgroundColor: 'transparent',
        borderColor: '#20a8d8',
        pointHoverBackgroundColor: '#3949AB',
        borderWidth: 2,
        data: []
      }
      var uploadcountChart = {
        label: 'QRコード出力',
        backgroundColor: 'transparent',
        borderColor: '#4dbd74',
        pointHoverBackgroundColor: '#00897B',
        borderWidth: 2,
        data: []
      }
      var downloadcountChart = {
        label: 'QRコードDL',
        backgroundColor: 'transparent',
        borderColor: '#ffc107',
        pointHoverBackgroundColor: '#FFB300',
        borderWidth: 2,
        data: []
      }
      var publiccountChart = {
        label: '公開数',
        backgroundColor: 'transparent',
        borderColor: '#f86c6b',
        pointHoverBackgroundColor: '#D81B60',
        borderWidth: 2,
        data: []
      }
      var privatecountChart = {
        label: '非公開数',
        backgroundColor: 'transparent',
        borderColor: '#c8ced3',
        pointHoverBackgroundColor: '#757575',
        borderWidth: 2,
        data: []
      }
      var deletecountChart = {
        label: '削除数',
        backgroundColor: 'transparent',
        borderColor: '#90A4AE',
        pointHoverBackgroundColor: '#546E7A',
        borderWidth: 2,
        data: []
      }
      var publicstatecountChart = {
        label: '現時点の公開数',
        backgroundColor: 'transparent',
        borderColor: '#2f353a',
        pointHoverBackgroundColor: '#757575',
        borderWidth: 2,
        data: []
      }
      for (var i = this.items.length - 1; i >= 0; i--) {
        var d = this.items[i]
        labels.push(d['time'])
        activeusersChart.data.push(d['activeusers'])
        uploadcountChart.data.push(d['uploadcount'])
        downloadcountChart.data.push(d['downloadcount'])
        publiccountChart.data.push(d['publiccount'])
        privatecountChart.data.push(d['privatecount'])
        deletecountChart.data.push(d['deletecount'])
        publicstatecountChart.data.push(d['publicstatecount'])
      }
      newData.labels = labels
      newData.datasets = [activeusersChart, uploadcountChart, downloadcountChart, publiccountChart, privatecountChart, deletecountChart, publicstatecountChart]
      this.chartData = newData
    }
  }
}
</script>

<style>
table{
  width: 100%;
}
th {
  background: #3e515b;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Aggregate.vue